/* eslint-disable @typescript-eslint/no-unused-vars */
// src/page-section/landing/IframeSection.tsx
import { cn } from "@/lib/utils";
import HeroSectionChildren from "@/wireframes/page-sections/hero/HeroSectionChildren";
import BlurIn from "@/wireframes/text-animations/blur-in";
import YouTubeEmbed from "@/components/iframe/iframe";

const IframeSection: React.FC = () => {
  const Media = () => {
    return (
      <div className="flex flex-col justify-center items-center">
        <div className="container mx-auto px-4 py-4 mb-10">
          <header className="text-center md:text-start mb-8 px-4 sm:my-10">
            <BlurIn
              word="Media"
              className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl leading-normal font-bold text-accent"
            />
          </header>
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-20">
            <div className="flex-1 flex justify-center items-center mt-10 lg:mt-0">
              <div className="w-full h-full aspect-w-16 aspect-h-9">
                <YouTubeEmbed
                  videoId="y0kGXf9CDso?si=kCDcEzjRC_X6sp94"
                  width={"100%"}
                />
              </div>
            </div>
            <div className="text-sm md:text-lg text-start max-w-3xl flex items-center">
              <h5 className="text-sm md:text-lg lg:text-xl font-normal text-start text-black">
              Vani is an innovative language learning app that transforms the way you learn languages. By simulating real-life conversations, Vani immerses you in the language from day one. Whether you’re a beginner or an advanced learner, Vani adapts to your proficiency level, making each lesson engaging and effective. Powered by the advanced Gemini API, the app offers real-time feedback, adaptive learning, and culturally relevant insights. Vani's unique approach helps you master new languages quickly and confidently, making it one of the best language learning apps available.
              </h5>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return <HeroSectionChildren id="media" children={<Media />} />;
};

export default IframeSection;
